<template>
  <header
    :class="[
      'v-header',
      {
        'v-header--with-image': !!imgSrc,
        'v-header--auto-height': !!autoHeight
      }
    ]"
    :style="{
      backgroundImage: !!imgSrc && `url('${imgSrc}')`,
      backgroundPosition: !!imgAlign && imgAlign
    }"
  >
    <slot name="navbar"></slot>
    <div v-if="hasContent" :class="['v-header__content', 'container-fluid', 'py-5']">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String
    },
    imgAlign: {
      type: String
    },
    autoHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasContent() {
      return !!this.$slots.default;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-header {
  position: relative;
  background-color: #fff;
  background-size: cover;
  background-position: center;
  min-height: 65vh;
  display: flex;
  flex-direction: column;

  &--auto-height {
    min-height: 0;
  }

  &--with-image {
    &::before {
      content: "";
      display: block;
      background-image: linear-gradient(
          90deg,
          rgba(242, 242, 244, 0.85) 25%,
          rgba(216, 216, 216, 0) 100%
        ),
        linear-gradient(
          -180deg,
          rgba(242, 242, 244, 0.85) 0%,
          rgba(255, 255, 255, 0) 100%
        );
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__content {
    position: relative;
    z-index: 1;
    flex: 1;
    display: flex;
    align-items: center;
  }
}
</style>
